import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, QuestionDTO } from '../../../../models/user-interests';
import { MatLegacyChip as MatChip, MatLegacyChipSelectionChange as MatChipSelectionChange } from '@angular/material/legacy-chips';

@Component({
  selector: 'app-tag-question',
  templateUrl: './tag-question.component.html',
  styleUrls: ['./tag-question.component.scss'],
})
export class TagQuestionComponent implements OnInit {
  @Input()
  question: Question;

  @Output()
  selected = new EventEmitter<string[]>();

  selectedTag: string;

  constructor() {}

  ngOnInit() {
    if (this.question && this.question.userResponsesForCurrentLevel) {
      this.selectedTag = this.question.userResponsesForCurrentLevel[0];
    }
  }

  chipClickedHandler(chip: MatChip) {
    if (chip.selected) {
      this.question.removeUserResponseFromCurrentLevel(chip.value);
    } else {
      this.question.provideUserResponseForCurrentLevel(chip.value);
    }
    this.selected.emit(this.question.userResponsesForCurrentLevel);
  }
}
